import { createGlobalStyle } from "styled-components";
import theme from "./theme";

const GlobalStyle = createGlobalStyle`
  html, body {
             -webkit-text-size-adjust: 100%;
             text-size-adjust: 100%; 
  }

  html {
		font-family: ${theme.fonts.base};
		font-size: 62.5%;
		line-height: normal;
		-webkit-font-smoothing: antialiased;
  }

  body {
  	margin: 0;
		color: ${theme.colors.black};
    font-size: ${theme.fontSizes[2]};
  }

	.ism {
		box-sizing: border-box;
		font-family: ${theme.fonts.base};

		*, *::before, *::after {
			box-sizing: inherit;
		}

		p {
			line-height: 1.6;
			font-size: 14px;
		}

		input[type="search"] {
			box-sizing: inherit;
		}
	}
`;

export default GlobalStyle;
